<p class="text-center my-4">
  Please select employer before leaving
</p>
<div>
  <app-dialog-footer
    (cancelAction)="close()"
    [cancelActionName]="'Go Back'"
    [valid]="true" />
</div>